import axios, { AxiosError } from 'axios';

import { ResponseTO } from '../../../types/response-to.type';
import { buildURL, handleResponseError } from '../../webservice';

const BASE_URL = process.env.REACT_APP_PAYMENTS_API_URL as string;

type ConfirmDirectDebitParams = {
    paymentId: number;
    userId: number;
    token: string;
    accessToken: string;
};

export const confirmDirectDebit = async ({
    paymentId,
    userId,
    token,
    accessToken,
}: ConfirmDirectDebitParams): Promise<ResponseTO> => {
    try {
        const url = buildURL(
            BASE_URL,
            `/v2/payments/${paymentId}/direct-debit/token`
        );
        const response = await axios.post<ResponseTO>(
            url,
            { userId, token },
            { headers: { Authorization: `Bearer ${accessToken}` } }
        );
        return response.data;
    } catch (err) {
        return handleResponseError(err as AxiosError);
    }
};
